const rawApiBase = String(process.env.REACT_APP_API_URL || '').trim();

function normalizeBase(base: string) {
  if (!base) return '';
  return base.replace(/\/+$/, '');
}

function normalizePath(path: string) {
  return path.startsWith('/') ? path : `/${path}`;
}

function buildDirectApiUrl(path: string) {
  const cleanPath = normalizePath(path);
  const base = normalizeBase(rawApiBase);
  if (!base) return `/api${cleanPath}`;
  if (base.endsWith('/api')) return `${base}${cleanPath}`;
  return `${base}/api${cleanPath}`;
}

export function buildApiUrl(path: string) {
  const cleanPath = normalizePath(path);
  if (process.env.NODE_ENV === 'development') {
    // En desarrollo usamos proxy de CRA (package.json -> proxy) para evitar CORS.
    return `/api${cleanPath}`;
  }
  return buildDirectApiUrl(cleanPath);
}

export function buildApiCandidates(path: string) {
  const primary = buildApiUrl(path);
  const candidates = [primary];

  if (process.env.NODE_ENV === 'development') {
    const direct = buildDirectApiUrl(path);
    if (direct && !candidates.includes(direct)) candidates.push(direct);
  }

  return candidates;
}
